import React from "react";

import { ZonedDateTime } from "@js-joda/core";
import { useTimezone } from "hooks/useTimezone";
import { localeOption } from "primereact/api";
import { useUserState } from "store/user-store";
import { DATE_FORMATTER_DAYS } from "utils/constants";
import { fmtDatetime, toZonedDateTime } from "utils/time-utils";
import { formatNumber } from "../charts/utils";

interface CellProps {
  color: string;
  className?: string;
  value?: number;
  date?: string;
  decimalPlaces?: number;
}

interface MonthProps {
  startDate: ZonedDateTime;
  index: number;
}

interface WeekDayProps {
  index: number;
}

const Cell = ({ color, className, value, date, decimalPlaces }: CellProps) => {
  const tz = useTimezone();

  const style = {
    backgroundColor: color,
  };

  const todayDate = ZonedDateTime.now(tz.company).toLocalDate();

  const zonedDateForCalc = date ? toZonedDateTime(date, tz.company) : undefined;

  const displayDate = date ? fmtDatetime(date, tz.display, DATE_FORMATTER_DAYS) : "";

  return (
    <div className={`timeline-cells-cell ${className}`} style={style}>
      {zonedDateForCalc && zonedDateForCalc.toLocalDate().isAfter(todayDate) ? (
        <div className="dot">.</div>
      ) : null}
      <div className="tooltip">
        {displayDate} {value !== undefined && formatNumber(value, decimalPlaces)}
      </div>
    </div>
  );
};

export default Cell;

const Month = ({ startDate, index }: MonthProps) => {
  const language = useUserState(state => state.getLanguage());
  const date = startDate.plusWeeks(index);

  const localizedMonth = localeOption("monthNamesShort", language ?? "en")?.[date.month().value() - 1];

  return (
    <div className={`timeline-months-month ${date.month().toString().toLowerCase()}`}>{localizedMonth}</div>
  );
};

const WeekDay = ({ index }: WeekDayProps) => {
  const language = useUserState(state => state.getLanguage());
  const dayName = localeOption("dayNamesShort", language)?.[(index + 1) % 7];
  return <div className="timeline-weekdays-weekday">{dayName}</div>;
};

export { Cell, Month, WeekDay };
